export const getDurationText = (duration: number, locale: 'ar' | 'en', short = false) => {
  const hours = Math.floor(duration / 60)
  const minutes = duration % 60

  // Language-specific translations
  const translations = {
    en: {
      hour: 'Hour',
      hours: 'Hours',
      minute: 'Minute',
      minutes: 'Minutes',
      hourShort: 'Hr',
      hoursShort: 'Hrs',
      minuteShort: 'Min',
      minutesShort: 'Mins',
    },
    ar: {
      hour: 'ساعة',
      hours: 'ساعات',
      minute: 'دقيقة',
      minutes: 'دقائق',
      hourShort: 'س',
      hoursShort: 'س',
      minuteShort: 'د',
      minutesShort: 'د',
    },
  }

  const lang = translations[locale as keyof typeof translations] || translations.en

  const hourUnit = short
    ? hours > 1
      ? lang.hoursShort
      : lang.hourShort
    : hours > 1
    ? lang.hours
    : lang.hour
  const minuteUnit = short
    ? minutes > 1
      ? lang.minutesShort
      : lang.minuteShort
    : minutes > 1
    ? lang.minutes
    : lang.minute

  const hourText = hours > 0 ? `${hours} ${hourUnit}` : ''
  const minuteText = minutes > 0 ? `${minutes} ${minuteUnit}` : ''

  return [hourText, minuteText].filter(Boolean).join(' ')
}
